import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, map, of, take, tap } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EntradasService {
  constructor(private http: HttpClient) {}
 
  obtenerEntradas(temas: any): Observable<any> {
    return this.http
      .post(`${environment.acuerdos.buscarEntradas}`, {
        temas,
      })
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data) => {
          return data;
        }),
        catchError((error) => {
          console.error("Error en obtenerAcuerdos", error);
          return of({ error: true, entradas: [], items: 0 });
        })
      );
  }

  elimminarEntrada(idEntrada: string): Observable<any> {
    return this.http
      .get(`${environment.acuerdos.eliminarEntrada}/${idEntrada}`)
      .pipe(
        tap((data) => console.log("API Response", data)),
        take(1),
        map((data) => {
          return data;
        }),
        catchError((error) => {
          console.error("Error en obtenerAcuerdos", error);
          return of({ error: true, entradas: [], items: 0 });
        })
      );
  }
}
